import { render, staticRenderFns } from "./OffShelfForm.vue?vue&type=template&id=f0f1dc98"
import script from "./OffShelfForm.vue?vue&type=script&lang=js"
export * from "./OffShelfForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports